import { useCallback, useState } from 'react';

import { saveUserProfile } from '../../../../../api/services/user/userService';
import { SaveUserProfile } from '../../../../../common/interfaces/accountsettings/profile/UserProfile';

/**
Custom hook to save the user profile using React Query.
@returns {object} - An object containing saveUser callback function, error, and loading state.
*/
export const useSaveUserProfile = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  // A callback function which we call to save user profile data
  const saveUser = useCallback(async (user: SaveUserProfile) => {
    try {
      setLoading(true);
      const data = await saveUserProfile(user);
      setLoading(false);
      return data;
    } catch (error: any) {
      setLoading(false);
      setError('Failed to save user Profile');
      throw Error(error.message);
    }
  }, []);

  return { saveUser, error, loading };
};
